import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { Lang } from '../types';
import _ from 'lodash';
import reducers from "../reducers";
import {persistCombineReducers} from "redux-persist";
import slices from "./index";
import storage from "redux-persist/lib/storage";
import { persistReducer } from 'redux-persist';

interface InitialStateType {
    newsList: Array<any>,
    questionsList: Array<any>,
    infoGraphics: Array<any>,
    posters: Array<any>,
}

const initialState = {
    newsList: [],
    questionsList: [],
    infoGraphics: [
        {
            id: 1,
            imgPath: `${process.env.PUBLIC_URL}/images/infographic/infographic1_{lang}.jpg`,
        },{
            id: 2,
            imgPath: `${process.env.PUBLIC_URL}/images/infographic/infographic2_{lang}.jpg`,
        },{
            id: 3,
            imgPath: `${process.env.PUBLIC_URL}/images/infographic/infographic3_{lang}.jpg`,
        },{
            id: 4,
            imgPath: `${process.env.PUBLIC_URL}/images/infographic/infographic4_{lang}.jpg`,
        },{
            id: 5,
            imgPath: `${process.env.PUBLIC_URL}/images/infographic/infographic5_{lang}.jpg`,
        },{
            id: 6,
            imgPath: `${process.env.PUBLIC_URL}/images/infographic/infographic6_{lang}.jpg`,
        }],
    posters: [
        {
            id: 1,
            imgPath: `${process.env.PUBLIC_URL}/images/posters/1_{lang}.jpg`,
        },{
            id: 2,
            imgPath: `${process.env.PUBLIC_URL}/images/posters/2_{lang}.jpg`,
        },{
            id: 3,
            imgPath: `${process.env.PUBLIC_URL}/images/posters/3_{lang}.jpg`,
        }
        ],
    videoLink:  (number: any, lang: string) =>{
        const isMO: any = lang==Lang.zhMO ? true : false;
        const isPT: any = lang==Lang.ptPT ? true : false;
        const isCN: any = lang==Lang.zhCN ? true : false;
        const introLinkId = 'tkJowpG7d48';
        const onlineLinkId = 'Nkkhq0pnFL0';
        const fillLinkId = 'Sq1H7ZCJcFY';
        const identifyLinkId = 'L27kKOwGWDM';
        const MO_linkArray = [
            `https://www.youtube.com/embed/${introLinkId}?loop=1&playlist=${introLinkId}`,
            `https://www.youtube.com/embed/${onlineLinkId}?loop=1&playlist=${onlineLinkId}`,
            `https://www.youtube.com/embed/${fillLinkId}?loop=1&playlist=${fillLinkId}`,
            `https://www.youtube.com/embed/${identifyLinkId}?loop=1&playlist=${identifyLinkId}`];
        const PT_linkArray = [
            `https://www.youtube.com/embed/${introLinkId}?loop=1&playlist=${introLinkId}`,
            `https://www.youtube.com/embed/${onlineLinkId}?loop=1&playlist=${onlineLinkId}`,
            `https://www.youtube.com/embed/${fillLinkId}?loop=1&playlist=${fillLinkId}`,
            `https://www.youtube.com/embed/${identifyLinkId}?loop=1&playlist=${identifyLinkId}`];
        const CN_linkArray = [
            `https://www.youtube.com/embed/${introLinkId}?cc_load_policy=1&loop=1&playlist=${introLinkId}&cc_lang_pref=zh-Hans`,
            `https://www.youtube.com/embed/${onlineLinkId}?cc_load_policy=1&loop=1&playlist=${onlineLinkId}&cc_lang_pref=zh-Hans`,
            `https://www.youtube.com/embed/${fillLinkId}?cc_load_policy=1&loop=1&playlist=${fillLinkId}&cc_lang_pref=zh-Hans`,
            `https://www.youtube.com/embed/${identifyLinkId}?cc_load_policy=1&loop=1&playlist=${identifyLinkId}&cc_lang_pref=zh-Hans`];
        const EN_linkArray = [
            `https://www.youtube.com/embed/${introLinkId}?cc_load_policy=1&loop=1&playlist=${introLinkId}&cc_lang_pref=en`,
            `https://www.youtube.com/embed/${onlineLinkId}?cc_load_policy=1&loop=1&playlist=${onlineLinkId}&cc_lang_pref=en`,
            `https://www.youtube.com/embed/${fillLinkId}?cc_load_policy=1&loop=1&playlist=${fillLinkId}&cc_lang_pref=en`,
            `https://www.youtube.com/embed/${identifyLinkId}?cc_load_policy=1&loop=1&playlist=${identifyLinkId}&cc_lang_pref=en`];

        if(isMO){
            return MO_linkArray[number];
        }
        else if(isPT){
            return PT_linkArray[number];
        }
        else if(isCN){
            return CN_linkArray[number];
        }
        else {
            return EN_linkArray[number];
        }
    }
} as InitialStateType;

export const dataSlice = createSlice({
    name: 'dataSlice',
    initialState: initialState,
    reducers: {
        setNewsList: (state, {payload}) => {
            state.newsList = payload;
        },
        getQuestionsList: (state) => {
        },
        setQuestionsList: (state, {payload}) => {
            state.questionsList = payload;
        },
    },
});

export const {
    setNewsList,
    getQuestionsList,
    setQuestionsList,
} = dataSlice.actions

export default dataSlice.reducer
